import Form from "@/ui/Form";
import { useRouter } from "next/router";
import Title from "@/ui/Title";
import styles from "./styles.module.scss";

export const FormSection = ({ title = "Upload CV", formId, jobId, redirect_url, variant }) => {
  const router = useRouter();

  function onSubmitDone() {
    router.push(redirect_url);
  }

  return (
    <section className={styles.formSection}>
      <div className={styles.header}>
        <h2>{title}</h2>
        <div className={styles.icon} />
      </div>
      <Form formId={formId} jobId={jobId} onSubmitDone={onSubmitDone} />
    </section>
  );
};

export default FormSection;
